module.exports = __webpack_public_path__ + "img/synapser_logo.b67a8a1d.png";